import _ from "lodash";
import { DEFAULT_PRODUCT_CODE, FALLBACK_PRODUCT_CODE } from "../constants";

export function validateRankData(rank, productLender, lenderID) {
  const lenders = productLender.lenders,
    keys = _.keys(lenders),
    maxLenderRank = keys.length,
    errors = [];

  if (rank > maxLenderRank) {
    let temp = {
      isValid: false,
      error: "Rank for lender is greater than expected range",
    };
    errors.push(temp);
  }

  _.forEach(keys, function (key) {
    if (rank === lenders[key].rank && rank !== -1) {
      let temp = {
        isValid: false,
        error: "Rank for lenders cannot be the same",
        lenderID: lenderID,
      };
      errors.push(temp);
    }
  });
  return errors;
}

export function calculatePercent(numerator, denominator) {
  if (denominator === 0 || numerator > denominator) {
    return 0;
  }

  const percent = Math.floor(((denominator - numerator) / denominator) * 100);
  return percent > 100 ? 100 : percent;
}

export function persistNewCycleMapperData(cycleData) {
  const formatCycleData = [];
  const newCycle = Object.values(cycleData);

  newCycle.forEach((product) => {
    if (product.product_limit_snapshot > 0) {
      const productData = {};
      const productLenders = Object.values(product.lenders);
      const productLendersData = productLenders.map((lender) => {
        const lenderData = {
          lender_id: lender.lender_id,
          lender_limit_snapshot: parseFloat(lender.lender_limit_snapshot),
          rank: parseInt(lender.rank),
        };
        return lenderData;
      });

      productData.lenders = productLendersData;
      productData.code = product.code;
      productData.product_limit_snapshot = parseFloat(
        product.product_limit_snapshot
      );
      formatCycleData.push(productData);
    }
  });
  return {
    cycle_products: formatCycleData,
    schedule_date: cycleData.scheduleDate,
  };
}

export function persistEditLenderRankMapperData(cycleData) {
  const formatCycleData = [];
  const newCycle = Object.values(cycleData);

  newCycle.forEach((product) => {
    const productData = {};
    const productLenders = Object.values(product.lenders);
    const productLendersData = productLenders.map((lender) => {
      const lenderData = {
        lender_id: lender.lender_id,
        rank: parseInt(lender.rank),
      };
      return lenderData;
    });

    productData.lenders = productLendersData;
    productData.code = product.code;
    formatCycleData.push(productData);
  });

  return {
    data: formatCycleData,
  };
}

export function getFallbackProductCode(code) {
  let productCode = code;
  if (code == DEFAULT_PRODUCT_CODE) {
    productCode = FALLBACK_PRODUCT_CODE;
  }
  return productCode;
}

export function validateProductAndLenderInputNumber(value, translate){
  let errorMessage = '';
  const isValidNum = /^\d+$/.test(value);
  if(value === 0){
    errorMessage = translate("errorMessages.ovo_admin_error_amount_greater_than_zero")
  } else if(!value){
      errorMessage = translate("errorMessages.ovo_admin_error_field_required")
  } else if (!isValidNum){
    errorMessage = translate("errorMessages.ovo_admin_error_invalid_value")
  }
  return errorMessage;
}